import ReactDOM  from "react-dom/client";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';

import App from "./App";
import './index.css';
i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(HttpApi)
    .init({
    fallbackLng: "en",
    detection : {
        order: ['path','cookie','htmlTag', 'localStorage','subdomain'],
        caches : ['cookie']
    },
    backend: {
        loadPath: '/locales/{{lng}}/translation.json',
    },
});

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(<App/>)